import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../primitives/tooltip";
import { formatRelativeTime } from "./utils";

const fullDateTimeFormat = new Intl.DateTimeFormat(undefined, {
  dateStyle: "full",
  timeStyle: "long",
});

export function RelativeTime({
  date,
  className,
  href,
}: {
  date: Date;
  className?: string | undefined;
  href?: string | undefined;
}) {
  const timeEl = (
    <time dateTime={date.toISOString()} className={className}>
      {formatRelativeTime(date)}
    </time>
  );

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          {href ? (
            <a href={href} className="hover:underline">
              {timeEl}
            </a>
          ) : (
            timeEl
          )}
        </TooltipTrigger>
        <TooltipContent side="top" sideOffset={4}>
          {fullDateTimeFormat.format(date)}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
